import { ArrayDataStore } from "Stores/RESTStoreInstances/ArrayDataStore";
import { qaDetailsStore } from "./QADetailsStore";
import { action, makeObservable, runInAction } from "mobx";
import { API } from "General/API";
import { handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { qaUnreadStore } from "./QAUnreadStore";

export class QAAnswersStore extends ArrayDataStore<API_Answer> {
  constructor() {
    super();
    makeObservable(this, {
      save: action.bound,
      put: action.bound,
      reject: action.bound,
      approve: action.bound,
    });
    this.data = [] as ArrayDataStore<API_Answer>["data"];
  }

  url(answerId?: number) {
    if (answerId) {
      return API_URL.QA.updateAnswer(projectsDataStore.projectId, answerId);
    } else {
      return API_URL.QA.createNewAnswer(projectsDataStore.projectId, qaDetailsStore.questionId);
    }
  }

  @handleStoreState()
  async save(formData: API_Answer, params: { role: API_QA_ROLE }) {
    try {
      const response = await API.newData<API_AnswerStatusUpdateResponse>(this.url(), formData, params);
      runInAction(() => {
        qaDetailsStore.setData(response.question);
        this.add(response.answer);
      });
      qaUnreadStore.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async put(answerId: number, formData: API_Answer, params: { role: API_QA_ROLE }) {
    try {
      const response = await API.editData(this.url(answerId), formData, params);
      runInAction(() => {
        this.edit(answerId, response, "id");
        // update question status by re-fetching it
        // qaDetailsStore.fetch();
      });
      qaUnreadStore.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async reject(answerId: number, _role: API_QA_ROLE) {
    const response: API_AnswerStatusUpdateResponse = await API.editData(
      API_URL.QA.categoryApprovalReject(projectsDataStore.projectId, answerId),
      {}
    );
    runInAction(() => {
      qaDetailsStore.setData(response.question);
      this.edit(answerId, response.answer, "id");
    });
  }

  @handleStoreState()
  async approve(answerId: number, _role: API_QA_ROLE) {
    const response: API_AnswerStatusUpdateResponse = await API.editData(
      API_URL.QA.approveAnswer(projectsDataStore.projectId, answerId),
      {}
    );
    runInAction(() => {
      qaDetailsStore.setData(response.question);
      this.edit(answerId, response.answer, "id");
    });
  }
}

export const qaAnswersStore = new QAAnswersStore();
